import { render, staticRenderFns } from "./AssignStylist.vue?vue&type=template&id=471cc79e&"
import script from "./AssignStylist.vue?vue&type=script&lang=js&"
export * from "./AssignStylist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports